module.exports = __webpack_public_path__ + "static/img/tuobuhua.3fbf07c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/e-wap/tuobuhua.png
// module id = 6
// module chunks = 0